import { render, staticRenderFns } from "./ShowModalityEmployees.vue?vue&type=template&id=33d79293&scoped=true"
import script from "./ShowModalityEmployees.vue?vue&type=script&lang=js"
export * from "./ShowModalityEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d79293",
  null
  
)

export default component.exports